"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tidyNumber = exports.TooltipOnOverflow = exports.NumericValue = exports.Paragraph = exports.TimeWithFormatter = exports.Time = exports.Text = exports.Subtle = exports.SubHeading = exports.LinkChild = exports.SmallHeading = exports.Heading = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var Heading_1 = require("./Heading");
Object.defineProperty(exports, "Heading", { enumerable: true, get: function () { return __importDefault(Heading_1).default; } });
var SmallHeading_1 = require("./SmallHeading");
Object.defineProperty(exports, "SmallHeading", { enumerable: true, get: function () { return __importDefault(SmallHeading_1).default; } });
var LinkChild_1 = require("./LinkChild");
Object.defineProperty(exports, "LinkChild", { enumerable: true, get: function () { return __importDefault(LinkChild_1).default; } });
var SubHeading_1 = require("./SubHeading");
Object.defineProperty(exports, "SubHeading", { enumerable: true, get: function () { return __importDefault(SubHeading_1).default; } });
var Subtle_1 = require("./Subtle");
Object.defineProperty(exports, "Subtle", { enumerable: true, get: function () { return __importDefault(Subtle_1).default; } });
var Text_1 = require("./Text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return __importDefault(Text_1).default; } });
var Time_1 = require("./Time");
Object.defineProperty(exports, "Time", { enumerable: true, get: function () { return Time_1.Time; } });
Object.defineProperty(exports, "TimeWithFormatter", { enumerable: true, get: function () { return Time_1.TimeWithFormatter; } });
var Paragraph_1 = require("./Paragraph");
Object.defineProperty(exports, "Paragraph", { enumerable: true, get: function () { return __importDefault(Paragraph_1).default; } });
var NumericValue_1 = require("./NumericValue");
Object.defineProperty(exports, "NumericValue", { enumerable: true, get: function () { return NumericValue_1.NumericValue; } });
var TooltipOnOverflow_1 = require("./TooltipOnOverflow");
Object.defineProperty(exports, "TooltipOnOverflow", { enumerable: true, get: function () { return TooltipOnOverflow_1.TooltipOnOverflow; } });
var formatting_1 = require("./formatting");
Object.defineProperty(exports, "tidyNumber", { enumerable: true, get: function () { return formatting_1.tidyNumber; } });
__exportStar(require("./Link"), exports);
__exportStar(require("./NavLink"), exports);
//# sourceMappingURL=index.js.map